import Vue from "vue";
import Vuex from "vuex";
import { TenantService } from "@/services/tenant.service";
import { HelperService } from "@/services/helper.service";

Vue.use(Vuex);

const state = {
  tenants: [],
  selected: {},
  loading: false,
  totalCount: 0
};

const getters = {
  tenants: state => state.tenants,
  onLoading: state => state.loading,
  selectedTenant: state => state.selected,
  total: state => state.totalCount
};

const mutations = {
  setSelected(state, sel) {
    state.selected = sel;
  },
  setList(state, sel) {
    state.tenants = sel;
  },
  setTotal(state, sel) {
    state.totalCount = Number(sel);
  },

  setLoading(state, sel) {
    state.loading = sel;
  }
};

const actions = {
  async ajaxTenantSetSelected({ commit }, payload) {
    await HelperService.genericSetSelected(
      commit,
      TenantService.fetchOne,
      payload.id
    );
  },

  async ajaxTenantFetchAll({ commit }, payloadFAP) {
    const searchFilterPagination = HelperService.localToJSONAPIPagination(
      payloadFAP
    );

    await HelperService.genericFetchAll(
      commit,
      TenantService.fetchAll,
      searchFilterPagination,
      null,
      null
    );
  },

  async ajaxTenantCreateOrUpdate({ commit }, payload) {
    return HelperService.genericCreateOrUpdate(
      commit,
      TenantService.createOrUpdate,
      payload
    );
  },

  async ajaxTenantDelete({ commit }, payload) {
    return HelperService.genericDelete(
      commit,
      TenantService.delete,
      payload.id
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
